import { KeyboardEvent, useEffect, useState } from 'react';

export function useKeyboardNavigation(props: {
	count: number;
	key: string | number;
	onEnter: (index: number) => void;
}) {
	const [selectedIndex, setSelectedIndex] = useState(0);

	useEffect(() => setSelectedIndex(0), [props.key]);

	return {
		selectedIndex,
		setSelectedIndex,
		onKeyDown: function <T>(event: KeyboardEvent<T>) {
			if (event.key === 'ArrowDown') {
				setSelectedIndex((selectedIndex + 1) % props.count);
				event.preventDefault();
				event.stopPropagation();
				return;
			}

			if (event.key === 'ArrowUp') {
				setSelectedIndex((selectedIndex - 1 + props.count) % props.count);
				event.preventDefault();
				event.stopPropagation();
				return;
			}

			if (event.key === 'Enter') {
				props.onEnter(selectedIndex);
				event.preventDefault();
				event.stopPropagation();
				return;
			}
		},
	};
}
